import React, { useContext } from 'react'
import BlockRenderer from '../components/shared/BlockRenderer'
import { graphql } from 'gatsby'
import { LayoutContext } from '../contexts'
import { useGlobal } from '../hooks/useGlobal'
import { SiteLink } from '../components/shared/SiteLink'
import BreadCrumb from '../components/shared/BreadCrumb'
import { desktopVW, mobileVW } from '../styles'
import theme from '../styles/theme'
import styled from 'styled-components'
import SEO from '../components/SEO'
import AmbassadorItem from '../components/shared/AmbassadorItem'

const { breakPoints, colors } = theme

const Ambassador = ({
  location,
  data: {
    contentfulPage: {
      name,
      seoTitle,
      seoDescription,
      seoImage,
      componentBlocks,
      layoutType,
    },
    relatedAmbassadors,
    allTrustPilotSummary: {
      nodes: [
        {
          score: { trustpilotStars },
          totalNumberOfReviews,
        },
      ],
    },
  },
}) => {
  const { node_locale } = useContext(LayoutContext)

  const { layout: dictionary } = useGlobal(['layout'], node_locale)

  return (
    <>
      <SEO
        isPage
        location={location}
        title={seoTitle}
        description={seoDescription}
        image={seoImage?.file?.url}
        noIndex={layoutType && layoutType.noIndex}
        referrer={location.state?.referrer}
      />
      <Header>
        <BreadCrumb>
          {dictionary?.home && <SiteLink>{dictionary.home}</SiteLink>}
          {' / '}
          {dictionary?.ambassadorOverview && (
            <SiteLink to={dictionary.ambassadorOverview.target?.slug}>
              {dictionary.ambassadorOverview.title}
            </SiteLink>
          )}{' '}
          / {name}
        </BreadCrumb>
      </Header>
      <div>
        <BlockRenderer
          blocks={componentBlocks}
          location={location}
          related={relatedAmbassadors.nodes.map((i) => (
            <AmbassadorItem key={i.id} data={i} />
          ))}
          rating={{
            totalNumberOfReviews,
            trustpilotStars,
          }}
        />
      </div>
    </>
  )
}

const Header = styled.div`
  margin: ${mobileVW(10)} auto;
  font-size: ${mobileVW(10)};
  width: 90%;
  color: ${colors.grey};

  @media screen and (min-width: ${breakPoints.desktop}) {
    max-width: ${desktopVW(1200, 1440)};
    font-size: ${desktopVW(12, 1440)};
    margin: ${desktopVW(40, 1440)} auto;
  }
`

export const pageQuery = graphql`
  query Ambassador($id: String!, $node_locale: String!) {
    contentfulPage(id: { eq: $id }) {
      id
      name
      seoTitle
      seoDescription
      seoImage {
        file {
          url
        }
      }
      layoutType {
        name
        noIndex
      }
      template
      componentBlocks {
        ...pageBlocks
      }
    }

    relatedAmbassadors: allContentfulPage(
      filter: {
        id: { ne: $id }
        node_locale: { eq: $node_locale }
        template: { eq: "Ambassador" }
      }
      limit: 3
    ) {
      nodes {
        ...ambassadorItem
      }
    }

    allTrustPilotSummary {
      ...pageRatings
    }
  }
`

export default Ambassador
